import { createRouter, createWebHistory } from 'vue-router'

import Routes from './components/routes'
import { auth } from './packs/plugins/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: Routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      // vue-router 4 で { x, y } から { left, top } に変わった
      return { left: 0, top: 0 }
    }
  }
});

// GoogleAnalytics
// vue-gtag は app.use で入れる必要があるので packs/application.js に移した

const loginCheck = (to, from, next) => {
  const loggedIn = to.matched.some(record => record.meta.isPublic) || auth.isLoggedIn
  const check = loggedIn && to.matched.some(record => record.meta.loginCheck && !record.meta.loginCheck(to, from, next, auth))
  return loggedIn && !check;
}

router.beforeEach((to, from, next) => {
  if (!loginCheck(to, from, next)) {
    const first = to.path.split('/')[1]
    if(first == 'admin' || first == 'su' || first == 'ep'){
      next({ path: '/' + first + '/login'});
    }else{
      next({ path: '/'});
    }
  } else {
    next();
  }
});


export default router;
